import styled, { css } from 'styled-components';

import { ConfirmModal } from '../../../components';
import { Container } from '../../../components/Modals/styled';

export const StyledTableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  border-radius: 16px;

  tr:hover {
    cursor: pointer;
  }

  table {
    padding: ${({ theme }): string => `${theme.spacers!.spacer02} ${theme.spacers!.spacer03}`};
  }

  td {
    min-width: 150px;

    &:nth-child(3) {
      display: grid;
      align-content: center;

      div {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        a {
          color: ${({ theme }): string => theme.admanColors!.blue.solid};
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 160%;
          letter-spacing: 0.14px;
          text-decoration: none;
        }
      }
    }
  }

  td:first-child {
    width: 30px;
    min-width: 30px;
    padding-right: ${({ theme }): string => theme.spacers!.spacer01};
  }

  td,
  th {
    &:last-child {
      padding-left: ${({ theme }): string => theme.spacers!.spacer03};
    }
  }
`;

export const StyledContent = styled.div(
  ({ theme }) => css`
    a {
      color: ${theme.admanColors!.blue.solid};
      font-weight: 500;
      text-decoration: none;
    }
  `
);

export const StyledConfirmModal = styled(ConfirmModal)`
  ${Container} {
    max-width: 600px;
    max-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    svg {
      path {
        fill: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
      }
    }

    > div {
      max-height: 310px;
      overflow: auto;
    }

    & > div:last-child {
      display: flex;
      justify-content: end;

      button {
        width: 204px;
        height: 48px;
      }
    }
  }
`;

export const StyledImage = styled.img`
  width: 48px;
  height: 48px;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledFilterToolbarWrapper = styled.div`
  position: relative;
`;

export const StyledMarkMessages = styled.div`
  position: absolute;
  top: 14px;
  left: 500px;
  font-family: Graphik;
  font-size: 14px;
  font-weight: 500;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

export const StyledNotificationDetails = styled.div<{ $isUnread?: boolean }>`
  font-weight: ${({ $isUnread }): string => ($isUnread ? '500' : '400')};
`;

export const StyledIndicator = styled.div`
  width: 8px;
  height: 8px;
  max-width: 8px;
  border-radius: 50%;
  background-color: ${({ theme }): string => theme.admanColors!.blue.dark.bg2[3]};
`;

export const StyledIndicatorWrapper = styled.div`
  width: 16px;
  max-width: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledMessageWrapper = styled.div`
  display: flex;
`;
